export const SelectionPersistenceKeys = {
  ActivitiesDrafts: "activities:drafts:selection",
  LinksDrafts: "links:drafts:selection",
  DocumentsDrafts: "documents:drafts:selection",
  ImagesActivityDrafts: "images:activity:drafts:selection",
};
